const LegacySizeGuide = () => null;
export default LegacySizeGuide;
